import { useRef, useState } from "react";
import { toast } from "sonner";
import { Music2, Upload, Trash2, Loader2 } from "lucide-react";
import api, { apiError } from "../../lib/api";
import { Button } from "../ui/button";

export const MusicPanel = ({ music, reload }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (files) => {
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append("file", f);
        await api.post("/admin/social/music", fd, { timeout: 120000 });
      }
      toast.success("Musique ajoutée"); reload();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  const remove = async (id) => {
    try { await api.delete(`/admin/social/music/${id}`); reload(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <section data-testid="social-music-panel" className="bg-white border border-[#ECE7DE] rounded-2xl p-4 sm:p-5">
      <div className="flex items-center justify-between gap-2 mb-3">
        <h3 className="flex items-center gap-2 text-sm font-bold text-[#1A1A1A]"><Music2 className="w-4 h-4 text-[#F26419]" />Musiques ({music.length})</h3>
        <Button size="sm" variant="outline" disabled={busy} onClick={() => input.current?.click()} data-testid="social-music-upload-btn">
          {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Upload className="w-4 h-4 mr-1" />}Ajouter des MP3
        </Button>
        <input ref={input} type="file" accept=".mp3,audio/mpeg" multiple hidden data-testid="social-music-input" onChange={(e) => e.target.files?.length && upload([...e.target.files])} />
      </div>
      {music.length === 0
        ? <p data-testid="social-music-empty" className="text-sm text-[#75807A]">Aucune musique : une nappe sonore Nold Go par défaut est utilisée. Ajoutez vos morceaux libres de droits, l'agent les fera tourner.</p>
        : <ul className="divide-y divide-[#F2EEE7]">
            {music.map((m) => (
              <li key={m.id} data-testid={`social-music-${m.id}`} className="flex items-center justify-between gap-2 py-2 text-sm">
                <span className="truncate min-w-0">{m.name}</span>
                <span className="flex items-center gap-3 shrink-0 text-xs text-[#75807A]">utilisée {m.uses || 0}×
                  <button onClick={() => remove(m.id)} data-testid={`social-music-delete-${m.id}`} className="text-[#B91C1C] hover:opacity-70"><Trash2 className="w-4 h-4" /></button>
                </span>
              </li>
            ))}
          </ul>}
    </section>
  );
};
